import * as apiGetUserCornerInfo from 'api/userCornerInfo/GetUserCornerInfoV1';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import { UserCornerInfo } from 'types/User/UserCornerInfo/UserCornerInfo';
import { defaultUserCornerInfo } from 'types/User/UserCornerInfo/UserCornerInfo';

export async function getUserCornerInfo(): Promise<UserCornerInfo> {
	const response = await apiGetUserCornerInfo.callApi();
	return response.orElse(defaultUserCornerInfo);
}

const rb = new ReducerBuilder<UserCornerInfo>();
export const userLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'user/LoadedFromBackend'
);

export const setReduxUser = rb.createActionForReducer(
	payloadReducer((x) => x),
	'user/SET'
);

export const userReducer = rb.createReducer();
